<template>
  <div id="contenedor-contratos-estatus-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'EtatusContratosMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
